/**
 * Global Imports
*/

import React from 'react';

/**
 * Root Imports
*/

import { Router } from '~/components/Router';

/**
 * Local Imports
*/

import { PermissionProvider } from '../../Providers';
import { IndexPermission } from '../../Views/Permissions';

/**
 * Exports
*/

/**
 * 
 */
export function PermissionRouter(props) {
  return (
    <Router
      provider={ PermissionProvider }
      routes={[
        {
          path: '',
          component: IndexPermission
        }
      ]}
    />
  );
}